import React from "react";
import { useState } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./Login.css";

import { updateData } from "../../hooks/update";

const Login = () => {
  const [forgotPass, setForgotPass] = useState("Forgot your password?");
  const navigate = useNavigate();
  const email = useRef("");
  const password = useRef("");

  const handleForgotPass = () => {
    setForgotPass("Contact Admin!");
  };

  const login = (e) => {
    e.preventDefault();
    sessionStorage.clear();
    const data = {
      email: email.current.value,
      password: password.current.value,
    };
    updateData("user/login", data, false, true, navigate, true);
  };

  return (
    <div className="h-[100vh]">
      <body class="align bodyStyle">
        <div class="divGrid align__item">
          <div class="register">
            <div className="flex justify-center pb-10">
              <img
                src="https://i.ibb.co/N9NxLtB/innovia-text-only-white-small.png"
                alt=""
                className="w-[70%] pb-2"
              />
            </div>

            <h2 className="h2Tag">Login</h2>

            <form onSubmit={login} class="form">
              <div class="form__field">
                <input
                  ref={email}
                  className="formInput"
                  type="text"
                  placeholder="Email"
                />
              </div>

              <div class="form__field">
                <input
                  ref={password}
                  className="formInput"
                  type="password"
                  placeholder="Password"
                />
              </div>

              <div class="form__field">
                <input className="formInput" type="submit" value="Sign In" />
              </div>
            </form>
            <button
              type="button"
              onClick={handleForgotPass}
              className="text-white font-normal"
            >
              {forgotPass}
            </button>
          </div>
        </div>
      </body>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Login;
